import React,{useEffect, useState} from 'react'
import { Container } from '../../Shared/FlexDiv/FlexDiv'
// import { Container,Row,Column } from '../../Shared/FlexDiv/FlexDiv'
import classes from './View.module.css'
import Map from './Map'
import Dashboard from './Dashboard'
import { isMobile } from '../../../Constants'
const View = ({
    // allowedLocations,
    currentSearchedLocation,
    analysisdata,
    offsetWidth,
    history,
    resetData,
    setcurrentLayer,
    currentLayer,
    detectedCoords

}) => {
    const [showDashboard, setshowDashboard] = useState(false)
    useEffect(() => {
        setshowDashboard(true)
    }, [])
    return (
        <Container className={classes['Container']}>
            {/* {console.log(analysisdata, 'analysisdata')} */}
            
            <Map 
                inflow={analysisdata.network && analysisdata.network.inflow?analysisdata.network.inflow:[]}
                inflowTransporterList={analysisdata && analysisdata.inflow_transporter_list ? analysisdata.inflow_transporter_list : []}
                inflowDashboard={analysisdata && analysisdata.inflow_dashboard ? analysisdata.inflow_dashboard : []}
                outflow={analysisdata.network && analysisdata.network.outflow?analysisdata.network.outflow:[]}
                outflowTransporterList={analysisdata && analysisdata.outflow_transporter_list ? analysisdata.outflow_transporter_list : []}
                outflowDashboard={analysisdata && analysisdata.outflow_dashboard ? analysisdata.outflow_dashboard : []}
                searched={ analysisdata.searched_coordinates?analysisdata.searched_coordinates:[]}
                analysisdata={analysisdata}
                transporter_list={analysisdata.transporter_list?analysisdata.transporter_list:[]}
                dashboard={analysisdata.dashboard ?analysisdata.dashboard:[]}
                offsetWidth={offsetWidth}
                currentSearchedLocation={currentSearchedLocation}
                transporter_count={analysisdata.transporters_count ?analysisdata.transporters_count:0}
                history={history}
                resetData={resetData}
                showSidebar={showDashboard}
                setcurrentLayer={setcurrentLayer}
                currentLayer={currentLayer}
                detectedCoords={detectedCoords}

            />
            {isMobile() ? null : showDashboard? 
                <button className={`btn btn-sm btn-primary ${classes['sidebaropenbutton']}`} onClick={e => {setshowDashboard(false)}}>
                    <i className="fa fa-door-open"/>
                </button>
            :
                <button className={`btn btn-sm btn-primary ${classes['sidebarclosedbutton']}`} onClick={e => {setshowDashboard(true)}}>
                    <i className="fa fa-door-open"/>
                </button>
            }
            {isMobile() ? null : showDashboard ?<div className={classes['newdashboard']}>
                <Dashboard 
                    transporter_count={analysisdata.transporters_count ?analysisdata.transporters_count:0} 
                    currentSearchedLocation={currentSearchedLocation} 
                    transporter_list={analysisdata.transporter_list?analysisdata.transporter_list:[]} 
                    dashboard={analysisdata.dashboard ?analysisdata.dashboard:[]}
                    setcurrentLayer={setcurrentLayer}
                    currentLayer={currentLayer}
                    inflowTransporterList={analysisdata && analysisdata.inflow_transporter_list ? analysisdata.inflow_transporter_list : []}
                    inflowDashboard={analysisdata && analysisdata.inflow_dashboard ? analysisdata.inflow_dashboard : []}
                    outflowTransporterList={analysisdata && analysisdata.outflow_transporter_list ? analysisdata.outflow_transporter_list : []}
                    outflowDashboard={analysisdata && analysisdata.outflow_dashboard ? analysisdata.outflow_dashboard : []}
                />
            </div>: null}
        </Container>
    )
}
export default View
